import { createMutationHook } from '../../admin/queries/createQuery';

/**
 * Reschedule booking mutation
 */
export const useRescheduleMutation = createMutationHook(
	'POST',
	'/gp-bookings/v1/manage/booking/reschedule'
);

/**
 * Cancel booking mutation
 */
export const useCancelMutation = createMutationHook(
	'POST',
	'/gp-bookings/v1/manage/booking/cancel'
);
